/** True when browser reports online (or navigator is unavailable). */
export const isAppOnline = () =>
  typeof navigator === 'undefined' || navigator.onLine;
